export default class TimelineSectionConfig {
  constructor({ componentName, key, isActive = false, canOpen = true }) {
    this.componentName = componentName;
    this.key = key || componentName;
    this.isActive = isActive;
    this.canOpen = !isActive && canOpen;
  }
}
